<div class="row">
  <div class="col-12">
    <app-outros-contatos-form [contato]="contato" [dataSet]="dataSet" [paginaEntidade]="paginaEntidade" [nomePagina]="nomePagina" (dadosTipoContatoIdEmit)="receberTipoContatoIdEmit($event)"></app-outros-contatos-form>
  </div>

  <div class="col-12">
    <nz-divider></nz-divider>
    <div class="col-12 d-flex flex-column page-content border border-radius w-100 mb-2">
      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
        (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
        <thead>
          <tr>
            <th nzColumnKey="tipoContato" nzShowSort [nzSortFn]="true">Tipo Contato</th>

            <ng-container *ngIf="paginaEntidade">
              <th nzColumnKey="areaAtuacao?.nomeAreaAtuacao" nzShowSort [nzSortFn]="true">Área de Atuação</th>
              <th nzColumnKey="nomeContato" nzShowSort [nzSortFn]="true">Nome</th>
              <th nzColumnKey="telefone" nzShowSort [nzSortFn]="true">Telefone</th>
              <th nzColumnKey="telefoneAdicional" nzShowSort [nzSortFn]="true">Outros Telefones</th>
              <th nzColumnKey="email" nzShowSort [nzSortFn]="true">E-mail</th>
              <th nzColumnKey="observacao" nzShowSort [nzSortFn]="true">Observações</th>
            </ng-container>

            <ng-container *ngIf="!paginaEntidade">
              <th nzColumnKey="principal" nzShowSort [nzSortFn]="true">Principal</th>
              <th nzColumnKey="email" nzShowSort [nzSortFn]="true">E-mail</th>
              <th nzColumnKey="telefone" nzShowSort [nzSortFn]="true">Telefone</th>
              <th nzColumnKey="enderecoBairro" nzShowSort [nzSortFn]="true">Bairro</th>
              <th nzColumnKey="enderecoMunicipio?.nome" nzShowSort [nzSortFn]="true">Município</th>
              <th nzColumnKey="enderecoUf?.nome" nzShowSort [nzSortFn]="true">Estado</th>
              <th nzColumnKey="pais?.nome" nzShowSort [nzSortFn]="true">País</th>
            </ng-container>

            <th class="text-center"nzWidth="80px" [nzRight]="true">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataSet">

            <td>{{ item?.tipoContato?.nomeTipoContato }}</td>

            <ng-container *ngIf="paginaEntidade">
              <td>{{ item?.areaAtuacao?.nomeAreaAtuacao }}</td>
              <td>{{ item?.nomeContato }}</td>
              <td>{{ item?.telefone | telefoneXX }}</td>
              <td>{{ item?.telefoneAdicional }}</td>
              <td>{{ item?.email }}</td>
              <td>{{ item?.observacao }}</td>
            </ng-container>

            <ng-container *ngIf="!paginaEntidade">
              <td>{{ item?.flagPrincipal === true ? 'Sim' : 'Não' }}</td>
              <td>{{ item?.email }}</td>
              <td>{{ item?.telefone }}</td>
              <td>{{ item?.enderecoBairro }}</td>
              <td>{{ item?.enderecoMunicipio?.nome }}</td>
              <td>{{ item?.enderecoUf?.nome }}</td>
              <td>{{ item?.pais?.nome }}</td>
            </ng-container>

            <td class="text-center" [nzRight]="true">
              <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                <span nz-icon nzType="more" nzTheme="outline"></span>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item type="button" (click)="editarItem(item)">
                    <a> Detalhes / Editar</a>
                  </li>
                  <li nz-menu-item type="button" (click)="removerContato(item)">
                    <a> Remover </a>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
          <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
